import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

import {AlphaCatalogue} from '../../../api/digitalCertificateApi';
import {CatalogFeature} from '../../../api/types/carvagoApiTypes';

/**
 * Maps every const_key of the alpha catalogue (vehicle-catalogue enums) to its label
 * in the requested language. Keys without a label in that language are skipped.
 */
export const getAlphaCatalogueLabels = (
  alphaCatalogue: AlphaCatalogue | Nullish
): Map<string, string> => {
  const labels = new Map<string, string>();

  alphaCatalogue?.forEach((property) =>
    property.keys?.forEach((key) => {
      const label = key.labels?.[0]?.label;

      if (!isNilOrEmpty(label) && !labels.has(key.const_key)) {
        labels.set(key.const_key, label);
      }
    })
  );

  return labels;
};

/**
 * Carvago API translates catalog features only into its own languages. For other certificate
 * languages the labels are taken from the alpha catalogue by const_key, falling back to the
 * label returned by Carvago.
 */
export const translateCatalogFeatures = (
  features: CatalogFeature[] | Nullish,
  alphaCatalogueLabels: Map<string, string>
): CatalogFeature[] | Nullish =>
  isNil(features)
    ? features
    : features.map((feature) => {
        const label = alphaCatalogueLabels.get(feature.const_key);

        return isNil(label) ? feature : {...feature, label};
      });
